import {
  SEND_TICKET_EMAIL_REQUEST,
  SEND_TICKET_EMAIL_SUCCESS,
  SEND_TICKET_EMAIL_FAIL,
  GET_TICKET_QUOTES_REQUEST,
  GET_TICKET_QUOTES_SUCCESS,
  GET_TICKET_QUOTES_FAIL
} from "./ticketActions";

const initialState = {
  emailSending: false,
  emailError: null,
  quotes: [],
  quotesLoading: false,
  quotesError: null
};

const ticketReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEND_TICKET_EMAIL_REQUEST:
      return {
        ...state,
        emailSending: true,
        emailError: null
      };
    case SEND_TICKET_EMAIL_SUCCESS:
      return {
        ...state,
        emailSending: false,
        emailError: null
      };
    case SEND_TICKET_EMAIL_FAIL:
      return {
        ...state,
        emailSending: false,
        emailError: action.error
      };
    case GET_TICKET_QUOTES_REQUEST:
      return {
        ...state,
        quotesLoading: true,
        quotesError: null
      };
    case GET_TICKET_QUOTES_SUCCESS:
      return {
        ...state,
        quotes: action.payload,
        quotesLoading: false,
        quotesError: null
      };
    case GET_TICKET_QUOTES_FAIL:
      return {
        ...state,
        quotesLoading: false,
        quotesError: action.error,
        quotes: []
      };
    default:
      return state;
  }
};

export default ticketReducer;
